module.exports = __webpack_public_path__ + "static/media/1.2889d07a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/ruined/1.mp3
// module id = 504
// module chunks = 0